// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./css/index.css
// module id = SZiR
// module chunks = 0